class MFRNokaMediaCarousel {
  constructor(i, e) {
    this.$index = i
    this.$element = $(e)

    this.selectors = {
      slider: ".carousel__slides",
      category: ".carousel__category",
      bar: ".flickity-page-dots .dot.is-selected",
      allBars: ".flickity-page-dots .dot",
    }

    this.options = {
      selectedAttraction: 0.1,
      friction: 0.55,
      prevNextButtons: false,
      contain: true,
      cellAlign: "center",
      pageDots: true,
      wrapAround: true,
      groupCells: false,
      imagesLoaded: true
    }

    this.autoplayTiming = 5

    this.timingArgs = {
      percentTime: 0,
      isPaused: false,
    }

    this.init()
  }

  init() {
    this.$carousel = this.$element.find(this.selectors.slider)
    this.$category = this.$element.find(this.selectors.category)
    this.$allBars = this.$element.find(this.selectors.allBars)
    
    this.$category.on("click", this.__handleCarouselChangeViaNavigation.bind(this))

    this.__handleCarouselInitialization()
    this.__handleCarouselChangeViaFlickity()
  }

  __handleCarouselInitialization() {
    this.$carousel.flickity({
      ...this.options,
      on: {
        change: () => {
          this.resetProgressbar()
          this.startProgressbar()
        },
      }
    })

    this.startProgressbar()
  }

  __handleCarouselChangeViaNavigation(event) {
    const $currentTarget = $(event.currentTarget)
    $currentTarget.addClass("is-active").siblings().removeClass("is-active")
    this.$carousel.flickity("selectCell", $currentTarget.data("index"))
  }

  __handleCarouselChangeViaFlickity() {
    this.$carousel.on("change.flickity", (event, index) => {
      const $currentNavTarget = Array.from(this.$category).filter(item => Number(item.dataset.index) === index)
      $($currentNavTarget).addClass("is-active").siblings().removeClass("is-active")
    })
  }

  // Carousel pagination autoplay functions
  startProgressbar() {
    this.resetProgressbar()
    this.timingArgs.percentTime = 0
    this.timingArgs.isPaused = false
    this.timingArgs.lastTimestamp = performance.now()
    this.timingArgs.tick = requestAnimationFrame(this.interval.bind(this))
  }

  interval(timestamp) {
    if (!this.timingArgs.isPaused) {
      this.timingArgs.percentTime += (timestamp - this.timingArgs.lastTimestamp) / (this.autoplayTiming * 1000)
      this.timingArgs.lastTimestamp = timestamp

      if (this.timingArgs.percentTime >= 1) {
        this.$carousel.flickity("next", true)
        this.startProgressbar()
      } else {
        this.$element.find(this.selectors.bar).css({ "--dynamic-width": (this.timingArgs.percentTime * 100).toFixed(2) + "%" })
        this.timingArgs.tick = requestAnimationFrame(this.interval.bind(this))
      }
    }
  }

  resetProgressbar() {
    this.$allBars.css({ "--dynamic-width": 0 + "%" })
    cancelAnimationFrame(this.timingArgs.tick)
  }
}